import gql from 'graphql-tag'

export default gql`
	mutation upsertUsers($records: [NewUser!]!) {
		cashAssist {
			upsertUsers(records: $records) {
				id
				name
				code
				printName
			}
		}
	}
`
